import { useFormikContext } from 'formik';

import { PaymentMethod } from 'types';
import { getPaymentMethodsWithProcessingFee } from 'utils/payments';

interface FormikValues {
  paymentMethods: PaymentMethod[];
}

export const useRemainderCart = (
  amount: number,
  isProcessingFeeEnabled?: boolean
) => {
  const { values: commonValues } = useFormikContext<FormikValues>();

  const currentAmount = getPaymentMethodsWithProcessingFee(
    commonValues.paymentMethods,
    isProcessingFeeEnabled
  );

  const remainder =
    amount && currentAmount < amount
      ? Number((amount - currentAmount).toFixed(2))
      : 0;

  const isBalanceZero = currentAmount >= amount;

  return { remainder, currentAmount, isBalanceZero };
};
